import { Link } from "react-router-dom";
import { AUTH_DISABLED, NEWS_ENABLED } from "@/lib/featureFlags";
import logo from "@/assets/logo-icon.png";

const NAV_LINKS = [
  { to: "/live", label: "Live" },
  { to: "/sack-race", label: "Sack Race" },
  { to: "/rankings", label: "MPI Rankings" },
  { to: "/pressure-index", label: "How MPI works" },
  ...(NEWS_ENABLED ? [{ to: "/news", label: "Manager Changes" }] : []),
  { to: "/compare", label: "Compare" },
];

const Footer = () => {
  return (
    <footer className="chrome-band mt-8 md:mt-14 border-t-2 border-brand">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid gap-8 md:grid-cols-3">
          {/* Identity */}
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <img src={logo} alt="" aria-hidden className="h-7 w-7" />
              <span className="font-display text-xl font-extrabold uppercase tracking-[-0.02em] text-chrome-foreground">
                Manager<span className="text-brand">Table</span>
              </span>
            </div>
            <p className="max-w-xs text-sm leading-relaxed text-chrome-muted">
              Home of the ManagerTable Pressure Index — every manager's tenure, form and
              pressure, measured the same way across Europe.
            </p>
          </div>

          {/* Navigation */}
          <div className="space-y-3">
            <h2 className="label-micro text-chrome-muted">Explore</h2>
            <ul className="space-y-2">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-chrome-foreground/80 transition-colors hover:text-brand"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Data & legal */}
          <div className="space-y-3">
            <h2 className="label-micro text-chrome-muted">Data &amp; legal</h2>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/coverage"
                  className="text-sm text-chrome-foreground/80 transition-colors hover:text-brand"
                >
                  Data &amp; Coverage
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-chrome-foreground/80 transition-colors hover:text-brand"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-sm text-chrome-foreground/80 transition-colors hover:text-brand"
                >
                  Terms of Use
                </Link>
              </li>
              {!AUTH_DISABLED && (
                <li>
                  <Link
                    to="/pricing"
                    className="text-sm text-chrome-foreground/80 transition-colors hover:text-brand"
                  >
                    Pricing
                  </Link>
                </li>
              )}
            </ul>
            <p className="pt-1 text-xs leading-relaxed text-chrome-muted">
              Data powered by Sportmonks.
            </p>
          </div>
        </div>

        <div className="mt-8 border-t border-chrome-border pt-5 text-xs leading-relaxed text-chrome-muted">
          ManagerTable is not affiliated with any football club, league, or manager. All
          trademarks and logos are property of their respective owners.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
